import BaseServiceCrud from './BaseServiceCrud';

export default class SettingService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'settings';
        this.getValue = this.getValue.bind(this);
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            locale: criteria.locale,
            name: criteria.name,
            setting_group: criteria.settingGroup?.enumValue,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getSupportedLocales() {
        return this.fetch(`${this.domain}/${this.path}/supported-locales`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    getImageSize() {
        return this.fetch(`${this.domain}/${this.path}/max-img-size`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    getValue(key) {
        return this.fetch(`${this.domain}/${this.path}/key/` + key, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }

    getCaptchaPublic() {
        return this.fetch(`${this.domain}/${this.path}/captcha`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }

    getVersionInfo() {
        return this.fetch(`${this.domain}/${this.path}/version`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getPasswordParamsPublic() {
        return this.fetch(`${this.domain}/${this.path}/passwords-params`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    getAppLinkUrl() {
        return this.fetch(`${this.domain}/${this.path}/app-url`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
}
